import { Teacher, User } from './../../../../../../interfaces/user';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Enrollment } from './../../../../../../interfaces/course';
import { ActivatedRoute, Router } from '@angular/router';
import { Lesson } from 'src/app/interfaces/course';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import * as _ from 'lodash';
import * as moment from 'moment';
import { State } from 'src/app/interfaces/enums';
import { map } from 'rxjs/operators';

import swal from 'sweetalert2';

import * as csv from 'csvtojson';
import { DataService } from 'src/app/services/data.service';

@Component({
  templateUrl: './lesson.component.html',
  styleUrls: ['./lesson.component.scss']
})
export class LessonComponent implements OnInit {
  lesson: Lesson;

  enrollments: Enrollment[];

  editingSession: string;

  form: FormGroup;
  editForm: FormGroup;
  isLoading = false;
  isAddingNewSession = false;
  isLoadingUpload = false;

  isEditing = false;

  toCreateZoomMeeting = false;

  State = State;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private data: DataService
  ) { }

  ngOnInit() {
    this.route.params.subscribe((p) => {
      if(p.courseid && p.lessonid){
        this.getLessons(p.courseid, p.lessonid);
      }
    })
  }

  /**
   * Function that gets data from the db
   * @param courseid course's ID
   * @param lessonid lesson's ID
   */
  async getLessons(courseid: string, lessonid: string){
    this.data.getLesson(courseid, lessonid).subscribe((res) => {
      this.lesson = null;

      if(res && res.data){
        this.lesson = res.data;

        if(!this.form){
          this.createForm();
          this.createEditForm();

          this.getEnrollments();
        }
      }
    })
  }


  /**
   * Function that checks if field has an error
   * @param field form's field
   */
  hasError(field: string){
    return this.form.get(field).invalid && this.form.get(field).touched && this.form.get(field).dirty;
  }

  /**
   * Function that allows to create/reset the form.
   */
  createForm(){
    if(this.form){
      this.form.reset();
    }else{
      this.form = this.fb.group({
        date: new FormControl('', [Validators.required]),
        subject: new FormControl('', [Validators.required]),
        startTime: new FormControl('', [Validators.required]),
        toCreateZoomMeeting: new FormControl(false),
        zoomMeetingHost: new FormControl('teacher'),
        zoomUrl: new FormControl(''),
        zoomId: new FormControl('')
      })
    }
  }

  async submit(){
    try{
      this.isLoading = true;

      const { value: data } = this.form;

      const startTime = moment(data.date).set({h: parseInt(_.first(_.split(data.startTime, ':'))), m: parseInt(_.last(_.split(data.startTime, ':')))});

      data.startTime = startTime.toISOString();
      data.endTime = startTime.add(this.lesson.course.session_duration, 'm').toISOString();

      if(data.toCreateZoomMeeting){
        let zoomId;
        if(data.zoomMeetingHost === 'teacher'){
          if(!(<Teacher>this.lesson.teacher).zoomId){
            throw Error('Teacher doesn\'t have zoom ID. Please go to teacher\'s profile to request');
          }

          zoomId = (<Teacher>this.lesson.teacher).zoomId;
        }

        if(data.zoomMeetingHost === 'host'){
          zoomId = 'CrqiQ6bDQLifEjYbnAC5OQ';
        }

        if(!zoomId){
          throw Error('Something went wrong.');
        }

        const {data: meetingData} = await this.data.createMeeting({
          start_time: startTime.toISOString(),
          userid: (<Teacher>this.lesson.teacher).zoomId,
          duration: this.lesson.course.session_duration,
          topic: data.subject
        }).toPromise();

        if(!meetingData || !meetingData.id || !meetingData.join_url){
          throw Error('Something went wrong.');
        }

        data.zoomUrl = meetingData.join_url;
        data.zoomId = meetingData.id;
      }

      this.data.addLessonSession(this.lesson.course_id, this.lesson._id, [data]).subscribe(() => {
        this.isAddingNewSession = false;

        this.getLessons(this.lesson.course_id, this.lesson._id);

        setTimeout(() => {
          this.createForm();
        }, 100);
      })

    }catch(e){
      this.toastr.error(e.message);
    }finally{
      this.isLoading = false;
    }
  }

  async getEnrollments(){
    this.data.getEnrollments({
      course: this.lesson.course_id,
      lesson: this.lesson._id,
      teacher: this.lesson.teacher_id
    }).subscribe((res) => {
      if(res && res.data){
        this.enrollments = res.data;
      }
    })
  }

  uploadSessions(){
    try{
      swal.fire({
        title: 'Upload sessions',
        inputPlaceholder: 'Select CSV file',
        inputOptions: {
          'accept': 'text/csv'
        },
        input: 'file',
        preConfirm: (v) => {
          if(v.type !== 'text/csv'){
            return 'Please select valid CSV file.';
          }

          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
              csv().fromString(reader.result.toString()).then((v) => {
                resolve(v);
              })
            };
            reader.readAsText(v);
          })
        },
        allowOutsideClick: () => !swal.isLoading(),
        showLoaderOnConfirm: true
      }).then(({value}) => {
        if(value && value.length){
          const result = [];

          for(let line of value){
            if(!line.date || !line.time || !line.subject || !line.zoomUrl || !line.zoomId){
              console.log('Row empty field error.');
              continue;
            }

            const date = moment(line.date);

            if(!date.isValid()){
              console.log('Row date error.');
              continue;
            }

            if(!/^[0-2][0-9]:[0-5][0-9]$/.test(line.time)){
              console.log('Row time error.');
              continue;
            }

            const startTime = date.set({h: parseInt(_.first(_.split(line.time, ':'))), m: parseInt(_.last(_.split(line.time, ':')))});

            result.push({
              startTime: startTime.toISOString(),
              endTime: startTime.add(this.lesson.course.session_duration, 'm').toISOString(),
              subject: line.subject,
              zoomUrl: line.zoomUrl,
              zoomId: line.zoomId,
              date: date.toDate(),
              state: State.Active
            })
          }

          if(result.length){
            swal.fire({
              type: 'info',
              text: `You have ${result.length} valid sessions. Do you want to upload?`,
              showCancelButton: true
            }).then(async ({value}) => {
              try{
                this.isLoadingUpload = true;

                if(value){
                  this.data.addLessonSession(this.lesson.course_id, this.lesson._id, result).subscribe(() => {
                    this.getLessons(this.lesson.course_id, this.lesson._id);
                  });
                }
              }catch({message}){
                this.toastr.error(message);
              }finally{
                this.isLoadingUpload = false;
              }
            })
          }else{
            swal.fire('Oops', 'No valid sessions', 'error');
          }
        }
      })

    }catch({message}){
      this.toastr.error(message);
    }
  }

  createEditForm(){
    this.editForm = this.fb.group({
      subtitle: new FormControl(this.lesson.subtitle, [Validators.required]),
      state: new FormControl(this.lesson.state, [Validators.required]),
      credits_per_session: new FormControl(this.lesson.credits_per_session, [Validators.required, Validators.pattern(/^(\d{1,})+(.\d{1,2})?$/i)]),
      teacher_rate_per_session: new FormControl(this.lesson.teacher_rate_per_session, [Validators.required, Validators.pattern(/^(\d{1,})+(.\d{1,2})?$/i)]),
     })
  }

  async deleteLesson(){
    this.data.deleteLesson(this.lesson.course_id, this.lesson._id).subscribe(() => {
      this.router.navigate(['/admin/courses', this.lesson.course_id]);
    })
  }

  async saveLesson(){
    try{
      if(this.editForm.invalid){
        throw Error('Form is invalid.');
      }

      const {value} = this.editForm;

      value.credits_per_session = parseInt(value.credits_per_session);
      value.state = parseInt(value.state);
      value.teacher_rate_per_session = parseFloat(value.teacher_rate_per_session);

      this.data.updateLesson(this.lesson.course_id, this.lesson._id, value).subscribe(() => {
        this.isEditing = false;
        this.getLessons(this.lesson.course_id, this.lesson._id);
      })

    }catch({message}){
      this.toastr.error(message);
    }
  }

  editLesson(){
    this.createEditForm();
    this.isEditing = true;
  }

  setLessonAs(){
    swal.fire({
      title: 'Set class as',
      input: 'select',
      inputOptions: {
        'featured': 'Featured class',
        'promotion': 'Promotioned class'
      }
    }).then(async ({value}) => {
      if(value){
        const newSettings: any = {};

        if(value === 'featured'){
          newSettings.featured = this.lesson._id
        }else{
          let promotions = await this.data.getSettings('configs').pipe(map((res) => res && res.data ? res.data.promotions : [])).toPromise();

          promotions.push(this.lesson._id);

          newSettings.promotions = promotions;
        }

        await this.data.updateSettings('configs', newSettings).toPromise();
      }
    })
  }
}
